import { CurrentUser, OmitFirst } from '@client/types';

function intercomDisabledVendors(): Set<string> {
  const raw = process.env.INTERCOM_DISABLED_VENDORS ?? '';
  return new Set(
    raw
      .split(',')
      .map((vendor) => vendor.trim())
      .filter(Boolean),
  );
}

export class IntercomService {
  appId: string;

  isDevEnv = process.env.NODE_ENV === 'development';

  constructor(intercomAppId: string) {
    this.appId = intercomAppId;
  }

  configure() {
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      const d = document;
      const i = function () {
        // eslint-disable-next-line prefer-rest-params
        i.c(arguments);
      };
      // @ts-expect-error: we don't need to type Intercom
      i.q = [];
      // @ts-expect-error: we don't need to type Intercom
      i.c = function (args) {
        i.q.push(args);
      };
      // @ts-expect-error: we don't need to type Intercom
      w.Intercom = i;
      const l = function (appId: string) {
        const s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = `https://widget.intercom.io/widget/${appId}`;
        document.body.appendChild(s);
      };
      l(this.appId);
    }
  }

  Intercom(
    command: Parameters<typeof window.Intercom>[0],
    ...params: OmitFirst<Parameters<typeof window.Intercom>>
  ) {
    if (this.isDevEnv) {
      // eslint-disable-next-line no-console
      console.log(command, ...params);
    }

    if (window.Intercom) {
      window.Intercom(command, ...params);
    } else {
      // eslint-disable-next-line no-console
      console.log(
        'Intercom has not loaded, please make sure an intercom app id is present and try again',
      );
    }
  }

  init(user: CurrentUser) {
    const vendor = user?.currentAccount?.vendor;
    if (vendor && intercomDisabledVendors().has(vendor)) {
      return;
    }

    if (this.appId) {
      if (!user?.isSuper) {
        window.intercomSettings = {
          app_id: this.appId,
          email: user?.email,
          name: user?.fullName,
          user_hash: user?.userHash,
          user_id: user?.uuid,
        };
      } else {
        window.intercomSettings = {
          app_id: this.appId,
        };
      }

      this.configure();
      this.Intercom('boot', window.intercomSettings);
    }
  }
}
